module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAIAAAD9b0jDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAFpJREFUeNpi/P//PwO1ARMDDcCooSPZUBZiFD158mTXrl1//vzR0dGxsrIaDdMBMJQRa4Hy6dOnjRs3fv/+Hb9mOzs7DQ2NAXXpaJIaIklqNExHDR1chgIEGADmdCcr8oseJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/maptool/ZOOMOUT_N.png
// module id = tRmB
// module chunks = 18